import React from "react";
import { Download } from "react-feather";
import { useSelector } from "react-redux";
import {
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from "reactstrap";

const TranscriptModal = ({ open, handleClose, handleDownloadReport }) => {
  const loadingTranscriptPdf = useSelector(
    (state) => state.downloadTranscript.loadingTranscriptPdf
  );
  const fileType = useSelector((state) => state.downloadTranscript.fileType);

  const formatNames = { pdf: "PDF", txt: "Text" };

  return (
    <Modal
      className="downloadTrascript"
      isOpen={open}
      scrollable
      size="lg"
      centered
    >
      <ModalHeader toggle={handleClose}>Downloading Transcripts</ModalHeader>
      <ModalBody>
        <Row className="align-self-center text-align-center text-center">
          <Col lg="12">
            <p>
              As there are too many sentences, the {formatNames[fileType]} will
              contain only a subset.
            </p>
            <p>(You can still see them all on the dashboard)</p>
          </Col>
          <Col lg="12" className="mt-2">
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleDownloadReport(fileType)}
              disabled={loadingTranscriptPdf}
            >
              {loadingTranscriptPdf ? (
                <Spinner size="sm" />
              ) : (
                <Download size={18} />
              )}{" "}
              Download {formatNames[fileType]}
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default TranscriptModal;
